/* eslint-disable no-console */
import axios from 'axios'

export default async function (): Promise<void> {
  try {
    // version.jsonファイルから最新のバージョンを取得（キャッシュ回避のタイムスタンプ付き）
    const res = await axios.get(`/version.json?_t=${Date.now()}`)
    const data = res.data
    const latestVersion = Number(data?.version)

    // 環境変数から現在のバージョンを取得
    const curVersion = process.env.CIRCLE_BUILD_NUM ? Number(process.env.CIRCLE_BUILD_NUM) : 0

    // 最新バージョンよりも古かった場合
    if (curVersion > 0 && latestVersion > 0 && curVersion < latestVersion) {
      // 無限ループ防止ガード: 同一バージョンに対してリロード試行済みかチェック
      const reloadKey = `shift_reload_attempt_${latestVersion}`
      if (typeof window !== 'undefined' && window.sessionStorage) {
        const attempted = window.sessionStorage.getItem(reloadKey)
        if (attempted) {
          console.warn(
            `[checkUpdate] New version ${latestVersion} available, but reload already attempted. Skipping to prevent loop.`
          )
          return
        }
        window.sessionStorage.setItem(reloadKey, 'true')
      }

      console.info(
        `[checkUpdate] Updating to new version: cur=${curVersion} -> latest=${latestVersion}`
      )
      if (typeof window !== 'undefined') {
        location.reload(true)
      }
    }
  } catch (error) {
    console.error('[checkUpdate] Error checking version:', error)
  }
}
